export default __webpack_public_path__ + "static/7-things-a-platinum-credit-card-can-do-for-you-concierge-a26cd7ac79e133d2be22e3ce95df37a7.jpg";